module.exports = __webpack_public_path__ + "static/media/AramarkTrailBlazer.13b3fe14.png";